// extracted by mini-css-extract-plugin
export var blogWavyPart1 = "blog-module--blogWavyPart1--ALEIp";
export var blogWavyPart2 = "blog-module--blogWavyPart2--InO0S";
export var blogTopSection = "blog-module--blogTopSection--kTZ7H";
export var blogTitleWrapper = "blog-module--blogTitleWrapper--luM78";
export var blogSearchBar = "blog-module--blogSearchBar--+AKw9";
export var blogImageWrapper = "blog-module--blogImageWrapper--3NN48";
export var blogMiddleSection = "blog-module--blogMiddleSection--+lo6C";
export var blogLeftArrow = "blog-module--blogLeftArrow--WUHI4";
export var blogArticlesWrapper = "blog-module--blogArticlesWrapper--fd9Bq";
export var blogArticlesLeftColumn = "blog-module--blogArticlesLeftColumn--J47Cc";
export var blogArticlesRightColumn = "blog-module--blogArticlesRightColumn--0THcI";
export var blogRightArrow = "blog-module--blogRightArrow--hAIeZ";
export var blogArticle = "blog-module--blogArticle--iQd8c";
export var blogBottomSection = "blog-module--blogBottomSection--uBr8v";
export var blogImageOfChildren = "blog-module--blogImageOfChildren--QFvkm";
export var blogCallToAction = "blog-module--blogCallToAction--3RquC";
export var inputContainer = "blog-module--inputContainer--JW1UR";
export var blogEmailInput = "blog-module--blogEmailInput--ipx0w";
export var emailMessage = "blog-module--emailMessage--Exoix";
export var submitButton = "blog-module--submitButton--km+JL";
export var spinner = "blog-module--spinner--fC+ir";
export var spin = "blog-module--spin--6NyJ7";